import Vue from 'vue'
import Vuex from 'vuex'

//import productList from './modules/productList'

Vue.use(Vuex)

// state
const state = {
    barIndex: 0, //记录底部菜单栏点击状态
    scrollTop: 0, //记录页面滚动距离
    routerTabs: [], //动态路由
    pathHistory: [], //记录前3个历史
    labelParams: '', //标签-搜索的参数
    scanCode: '', //APP扫码
    auroraPush: '', //标徽
    okrTitle: '',
    valueListener: false, // 监控form表单是否变化
    //entryPath: location.hash.split('?')[0].slice(1), //入口路径，不会变
}

// getters
const getters = {
    auroraPush: (state, getters) => {
        return state.auroraPush
    },
    scanCode: (state, getters) => {
        return state.scanCode
    },
    barIndex: (state, getters) => {
        return state.barIndex
    },
    scrollTop: (state, getters) => {
        return state.scrollTop
    },
    routerTabs: (state, getters) => {
        return state.routerTabs
    },
    //当前页面是否支持返回。存在历史，且当前页不是首页
    canGoBack: (state) => {
        var history = state.pathHistory
        var cur = history[history.length - 1];
        var last = history[history.length - 2];
        if (last) {
            return last && cur.path !== '/'
        } else {
            return cur.path !== '/'
        }
        
    },
    labelParams: (state, getters) => {
        return state.labelParams
    },
    okrTitle: (state, getters) => {
        return state.okrTitle
    },
    valueListener: (state, getters) => {
        return state.valueListener
    },
}

// actions
const actions = {
    setAuroraPush({ commit }, index) {
        commit('SET_AURORAPUSH', index)
    },
    setScanCode({ commit }, index) {
        commit('SET_SCANCODE', index)
    },
    setBarIndex({ commit }, index) {
        commit('SET_BARINDEX', index)
    },
    setScrollTop({ commit }, index) {
        commit('SET_SCROLLTOP', index)
    },
    setRouterTabs({ commit }, tabs) {
        commit('SET_ROUTERTABS', tabs)
    },
    pushRoutePath({ commit }, path) {
        commit('PUSH_PATH', path)
    },
    setLabelParams({ commit }, index) {
        commit('SET_LABELPARAMS', index)
    },
    setOkrTitle({ commit }, index) {
        commit('SET_OKRTITLE', index)
    },
    setValueListener({ commit }, index) {
        commit('SET_VALUELISTENER', index)
    },
};

// mutations
const mutations = {
    SET_AURORAPUSH(state, index) {
        state.auroraPush = index
    },
    SET_SCANCODE(state, index) {
        state.scanCode = index
    },
    SET_BARINDEX(state, index) {
        state.barIndex = index
    },
    SET_SCROLLTOP(state, index) {
        state.scrollTop = index
    },
    SET_ROUTERTABS(state, index) {
        state.routerTabs = index
    },
    PUSH_PATH(state, route) {
        var history = state.pathHistory;
        var cur = history[history.length - 1];
        var last = history[history.length - 2]
        if (last && last.path === route.path) history.splice(history.length - 1, 1) //后退操作，弹出历史
        else if (!cur || cur.path !== route.path) history.push(route)
        if (history.length > 3) history.splice(0, 1)
    },
    SET_LABELPARAMS(state, index) {
        state.labelParams = index
    },
    SET_OKRTITLE(state, index) {
        state.okrTitle = index
    },
    SET_VALUELISTENER(state, index) {
        state.valueListener = index
    },
}

export default new Vuex.Store({
    namespaced: true,
    state,
    getters,
    actions,
    mutations,
    //modules: {
    //productList,
    //},
})
